<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar>
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:right>
        <div class="d-flex align-center" style="margin: 0 10px">
          <span style="font-size: 19px;">{{ total }}件</span>
        </div>
        <div class="d-flex align-center">
          <CSelect
                  style="padding: 0; width: 210px; margin-bottom: 0;"
                  :options="perPageOptions"
                  :value="perPage"
                  @update:value="onChangePerPage"
                  label="1ページあたり:"
                  :horizontal="{ label: 'sm-7', input: 'sm-5'}"
          >
          </CSelect>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click.stop="onFilter">
              <v-badge :value="filtered" dot top color="red" offset-x="8" offset-y="8">
                <v-icon>mdi-filter-outline</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>フィルタ</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onRefresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </template>
    </ToolBar>
    <CHeader :class="$style['toolbar']" height="45" color="grey lighten-4" elevation="0">
      <v-toolbar-items :class="$style['left']">
        <div class="d-flex align-center" style="margin: 0 10px">
          <span style="font-size: 18px;">質問テキスト: {{ questionText }}</span>
        </div>
      </v-toolbar-items>
    </CHeader>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <v-layout column fill-height>
          <v-flex grow>
            <div :class="$style['main-content']" class="table-responsive">
              <CDataTable
                :items="answers"
                :fields="columnsForTable"
                hover
                :loading="loading"
                :clickableRows="true"
                @update:sorter-value="sortBy"
                :sorter='{ external: true, resetable: false }'
                style="font-size: 13px !important;"
                :noItemsView='{ noResults: "データが存在しません", noItems: loading ? "読込中" : "データが存在しません" }'
              >
              <template #sex="{ item }">
                <td>
                  <span>
                    {{ sex(item.sex) }}
                  </span>
                </td>
              </template>
              <template #user_type="{ item }">
                <td>
                  <span>
                    {{ userType(item.user_type) }}
                  </span>
                </td>
              </template>
            </CDataTable>
          </div>
          </v-flex>
          <v-flex :class="$style['container-footer']">
            <CPagination
            :pages="pageLength"
            :activePage="currentPage"
            @update:activePage="onChangePage"
            align="center"
            style="margin-top: 5px"
            >
          </CPagination>
          </v-flex>
        </v-layout>
      </v-content>
    </div>
    <FilterModal :resourceName="resourceName" :columns="columns" />
  </v-container>
</template>

<script>
import ToolBar from "@/components/app/toolbar";
import FilterModal from "@/components/filter-modal";
import utility from "@/utility";
import Breadcrumb from "@/components/app/breadcrumb";
import Datepicker from 'vuejs-datepicker'

//日本語化
import {ja} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';

export default {
  components: {
    ToolBar,
    Breadcrumb,
    FilterModal,
    Datepicker,
  },
  props: {
    productId: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      resourceName: "answers",
      pk: "id",
      columns: [
        {
          value: "name",
          text: "回答者名",
          filter: true
        },
        {
          value: "age",
          text: "回答者年齢",
          filter: true,
          type: 'number'
        },
        {
          value: "sex",
          text: "回答者性別",
          filter: true,
          type: 'select',
          optionType: "common/genders"
        },
        {
          value: "user_type",
          text: "回答者会員属性",
          filter: true,
          type: 'select',
          optionType: "common/user_types"
        },
        {
          value: "large_location",
          text: "回答者店舗所在地",
          filter: true,
          type: 'select',
          optionType: "common/large_locations"
        },
        {
          value: "business_scale",
          text: "回答者店舗規模",
          filter: true,
          type: 'select',
          optionType: "common/business_scales"
        },
        {
          value: "average_spending",
          text: "回答者客単価",
          filter: true,
          type: 'select',
          optionType: "common/avarage_spendings"
        },
        {
          value: "answer",
          text: "回答",
          filter: true
        },
      ],
      perPageOptions: [
        { value: 20, label: '20件' },
        { value: 50, label: '50件' },
        { value: 100, label: '100件' }
      ],
      ja:ja,
      targetDate: null
    }
  },
  computed: {
    loading() {
      return this.$store.getters[`${this.resourceName}/list/isLoading`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/list/isProcessing`];
    },
    answers() {
      return this.$store.getters[`${this.resourceName}/list/answers`];
    },
    total() {
      return this.$store.getters[`${this.resourceName}/list/total`];
    },
    currentPage() {
      return this.$store.getters[`${this.resourceName}/list/page`];
    },
    perPage() {
      return this.$store.getters[`${this.resourceName}/list/perPage`];
    },
    pageLength() {
      return this.$store.getters[`${this.resourceName}/list/pageLength`];
    },
    questionText() {
      return this.$store.getters[`${this.resourceName}/list/questionText`];
    },
    filters() {
      return this.$store.getters["filters/filters"];
    },
    shouldFetch() {
      return this.$store.getters["filters/shouldFetch"];
    },
    filtered() {
      return this.$store.getters["filters/filtered"];
    },
    sort() {
      return this.$store.getters[`${this.resourceName}/list/sort`];
    },
    columnsForTable() {
      let columnFiltered = this.columns.filter(column => {
        return !(column.isProvider && !this.isProvider);
      });

      let columns = columnFiltered.map(column => {
        if(!(column.isProvider && !this.isProvider)) {
          return {
            key: column.value,
            label: column.text,
            filter: column.filter === undefined ? true : column.filter,
            sorter: column.sorter === undefined ? true : column.sorter,
            _style: 'width:' + column.width + ';'
          };
        }
      });

      return columns;
    },
    condiments() {
      return this.$store.getters["recipes/list/condiments"];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    selected() {
      return this.$store.getters[`${this.resourceName}/list/selected`] || [];
    },
    allSelected() {
      return this.$store.getters[`${this.resourceName}/list/allSelected`];
    }
  },
  watch: {
    shouldFetch(should) {
      if (should) {
        this.fetch(this.currentPage)
          .then(() => {
            this.$store.commit("filters/fetched");
          })
          .catch(() => {
            this.$store.commit("filters/fetched");
          });
      }
    }
  },
  methods: {
    fetch(page) {
      let params = {
        id: this.$route.params.pk,
        productId: this.productId,
        page,
        filters: this.filters,
        sort: this.sort
      };

      return this.$store.dispatch(`${this.resourceName}/list/indexAnswers`, params);
    },
    onRefresh() {
      this.fetch(this.currentPage);
    },
    onFilter() {
      this.$store.commit("filters/open");
    },
    onChangePage(page, reduced) {
      this.fetch(page);
    },
    onChangePerPage(perPage) {
      this.$store.dispatch(`${this.resourceName}/list/changePerPage`, {
        perPage
      });
      this.fetch(1);
    },
    onHeaderClick(columnClicked) {
      if (columnClicked.property === "buttons") {
        return;
      }

      const column = this.columns.find(
        column => column.name === columnClicked.property
      );

      if (!column.sortable) {
        return;
      }

      this.$store.commit(`${this.resourceName}/list/setSort`, {
        field: columnClicked.property,
        type: column.type || ""
      });

      this.fetch(this.currentPage);
    },
    sortBy(options) {
      const {column, asc} = options;

      if (column.length) {
        const field = column;
        const direction = asc ? "asc" : "desc";
        const target = this.columnsForTable.find(v => v.value === field) || {};
        const {type, sortable} = target;

        if (sortable === false) {
          return;
        }

        this.$store.commit(`${this.resourceName}/list/setSort`, {
          field,
          type,
          direction
        });

        this.fetch(this.currentPage);
      }
    },
    sex(value) {
      switch (value) {
        case 1:
          return '男性';
        case 2:
          return '女性'
        default:
          return '';
      }
    },
    userType(value) {
      switch (value) {
        case 1:
          return '一般ユーザ';
        case 2:
          return '飲食人'
        default:
          return '';
      }
    }
  },
  created() {
    this.$store.commit(`${this.resourceName}/entity/initialize`);
    this.$store.dispatch("filters/initialize");
    this.fetch(1);
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-app-subheader-height: 60px;
$base-index-header-height: 60px;
$base-index-footer-height: 60px;

.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;
  position: relative;
  background-color: #fff;

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-index-header-height});

    .main-content {
      display: flex;
      position: relative;
      flex-direction: column;
      height: calc(
        100vh - #{$base-index-header-height} - #{$base-index-footer-height} - #{$base-app-subheader-height}
      );

      :global(.v-data-table.v-data-table--fixed-header) {
        width: 100%;
        position: relative;
        height: calc(
          100vh - #{$base-index-header-height} - #{$base-index-footer-height}
        );

        :global(.v-data-table__wrapper) {
          height: 100%;
        }
      }

      th > div{
        width: max-content;
      }

      input[type=checkbox] {
        width:			16px;
        height:			16px;
        -moz-transform:		scale(1.15);
        -webkit-transform:	scale(1.15);
        transform:		scale(1.15);
      }
    }
  }

  .container-footer{
    background-color: #fff;
  }

  .pagination {
    height: $base-index-footer-height !important;
  }
}

.control-button{
  width: 60px !important;
}
.control-button-wide {
  width: 120px !important;
}
.control-button-extra-wide {
  width: 150px !important;
}

.toolbar-total {
  position: absolute;
  right: 300px;
}

.datepicker{
  div > input{
    border: 1px ridge #333333;
    display: block;
    margin: 5px 5px 10px;
  }
}
</style>
<style lang="scss">
  select{
    -moz-appearance: auto !important;
    -webkit-appearance: auto !important;
  }

  .form-check-input {
    width: 15px;
    height: 15px;
  }

  .text-bold {
    font-weight: bold !important;
  }
</style>
<style lang="scss">
.nav-tabs {
  .nav-item {
    .nav-link {
      color: #123457 !important;
    }
  }
}
</style>